export const WAREHOUSE_SCOPE = {
    DEFAULT: 'default',
    CLONE: 'clone',
}
